import * as service from './service'
export default {
  namespace: 'EquipmentAudit',
  state: {
    queryEquipsData: {}
  },
  effects: {
    * queryEquips ({ payload }, { call, put }) {
      const res = yield call(service.queryEquips, payload)
      yield put({
        type: 'save',
        payload: {
          queryEquipsData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
